import { GlobalOutlined } from "@ant-design/icons"
import { Flex, Select, type SelectProps, Typography } from "antd"
import React, { useMemo } from "react"

import { TIMEZONE_GROUPS } from "../../constants/timezones.ts"

const { Text } = Typography

export function TimezoneSelect(props: SelectProps) {
  const options = useMemo(
    () =>
      TIMEZONE_GROUPS?.map((group) => ({
        label: <Text type="secondary">{group?.label}</Text>,
        title: group?.label,
        options: group?.options?.map((option) => ({
          value: option.value,
          label: (
            <Flex justify="space-between">
              <Text>{option?.label}</Text>
              <Text type="secondary">
                {option?.offset} {option?.abbr ? `(${option?.abbr})` : ""}
              </Text>
            </Flex>
          ),
          searchText: option?.label?.toLowerCase()
        }))
      })),
    []
  )

  return (
    <Select
      placeholder="Select timezone"
      suffixIcon={<GlobalOutlined />}
      notFoundContent="No timezone found"
      options={options}
      {...props}
    />
  )
}
